import type { Composition, Reference } from '@medplum/fhirtypes'
import { ExtendedComposition } from '@seen/core/models/compositions/composition'
import { compositionUrl } from '@seen/core/models/compositionUrl'
import { cn } from '@seen/ui'
import { IconFileText } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useRead } from '#src/hooks/useRead.ts'

const chipClassName =
  'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)]'

export function CompositionMention({
  composition: compositionReference,
  className,
  displayOverride,
}: {
  composition: Reference<Composition>
  className?: string
  displayOverride?: string | null
}): JSX.Element {
  const { data: composition } = useRead(
    ExtendedComposition,
    compositionReference
  )

  const url = composition ? compositionUrl(composition.toFhirResource()) : null

  const content = (
    <>
      <span>
        <IconFileText className="inline-block size-[1em] align-[-0.25ex]" />
      </span>
      <span> {displayOverride || composition?.title}</span>
    </>
  )

  if (!url) {
    return <span className={cn(chipClassName, className)}>{content}</span>
  }

  return (
    <Link
      to={url}
      className={cn(
        chipClassName,
        'hover:bg-gray-460 [&&]:no-underline',
        className
      )}
      tabIndex={-1}
    >
      {content}
    </Link>
  )
}
